
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6C6C6C"}},[_c('path',{attrs:{"d":"M15.686 6.069c.174 0 .314-.14.314-.314V3.626a.314.314 0 00-.314-.313H.314A.314.314 0 000 3.626v2.129c0 .173.14.314.314.314 1.071 0 1.943.871 1.943 1.943A1.945 1.945 0 01.314 9.954a.314.314 0 00-.314.314v2.129c0 .173.14.314.314.314h2.79a.314.314 0 100-.628H.628v-1.52a2.574 2.574 0 002.256-2.551A2.574 2.574 0 00.628 5.46V3.94h10.779v.628a.314.314 0 10.627 0V3.94h3.338v1.52a2.574 2.574 0 00-2.256 2.552c0 1.31.986 2.396 2.256 2.551v1.52h-3.338v-.628a.314.314 0 00-.627 0v.628H5.68a.314.314 0 100 .628h10.005c.174 0 .314-.14.314-.314v-2.129a.314.314 0 00-.314-.314 1.945 1.945 0 01-1.943-1.942c0-1.072.872-1.943 1.943-1.943z"}}),_c('path',{attrs:{"d":"M11.72 9.473c.173 0 .314-.14.314-.313V6.864a.314.314 0 10-.628 0V9.16c0 .173.14.313.314.313zM6.683 7.566c.233-.232.361-.542.361-.87a1.233 1.233 0 00-2.464 0 1.228 1.228 0 001.232 1.231c.316 0 .631-.12.871-.36zm-1.475-.87a.6.6 0 01.604-.605.602.602 0 01.427 1.032.605.605 0 01-1.031-.428zM7.757 8.607a1.233 1.233 0 001.742 1.743c.48-.48.48-1.262 0-1.743a1.234 1.234 0 00-1.742 0zm1.298.444a.605.605 0 11-.856.855.605.605 0 01.856-.855zM5.802 9.956l3.27-3.269a.314.314 0 00-.445-.444l-3.269 3.27a.317.317 0 00-.018.423c.117.139.334.148.462.02zM4.388 12.08c-.131 0-.251.085-.296.208a.316.316 0 00.096.348.317.317 0 00.36.028.316.316 0 00.148-.329.317.317 0 00-.308-.255z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    